import React from 'react'
import { Col, Row, Spin } from 'antd'
import { useAppSelector } from 'hooks/reduxHooks'

import MsToTime from 'utils/msToTime'
import styles from './styles.module.scss'

const BroadcastFormEstimates: React.FC = () => {
	const { broadcast, loading: broadcastLoading } = useAppSelector(
		state => state.broadcast
	)

	const completionTime = broadcast?.completionTime

	const balanceAfterBroadcast =
		// (wallet?.amount.credit || 0) - (broadcast?.cost || 0)
		0 - (broadcast?.cost || 0)

	return (
		<Spin spinning={broadcastLoading} tip='Getting Estimates'>
			<div className={styles.BroadcastFormEstimates}>
				<Row gutter={16}>
					<Col span={12}>
						<div className={styles.BroadcastFormEstimates_heading}>Estimate</div>
						<div className={styles.BroadcastFormEstimates_table}>
							<Row className={styles.BroadcastFormEstimates_table_row}>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_heading}
								>
									Cost
								</Col>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_content}
								>
									Rs. {(broadcast?.cost || 0).toFixed(2)}
								</Col>
							</Row>
							<Row className={styles.BroadcastFormEstimates_table_row}>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_heading}
								>
									Time
								</Col>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_content}
								>
									{MsToTime(completionTime?.toString() ?? '0')} to send as per your
									current limit.
								</Col>
							</Row>
							<Row
								className={styles.BroadcastFormEstimates_table_row}
								hidden={broadcast?.status !== 'DRAFT'}
							>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_heading}
								>
									Wallet Balance after broadcast
								</Col>
								<Col
									span={12}
									className={styles.BroadcastFormEstimates_table_row_content}
								>
									Rs. {balanceAfterBroadcast.toFixed(2)}
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
			</div>
		</Spin>
	)
}

export default BroadcastFormEstimates
